import React from 'react';
import Sidebar from './Sidebar';

type LayoutProps = {
  children: React.ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-white">
      <Sidebar />

      <div className="pl-[180px]">
        <header className="bg-white h-16 border-b border-gray-200 flex items-center justify-between px-6">
          <div />
          <div className="flex items-center space-x-4">
            <div className="relative">
              <div
                className="w-8 h-8 rounded-full border border-gray-400 flex items-center justify-center"
                style={{ background: '#29446D' }}
              >
                <span
                  className="text-white font-bold"
                  style={{ fontSize: '14px', fontFamily: 'Roboto, sans-serif', fontWeight: '700' }}
                >
                  U
                </span>
              </div>
            </div>
          </div>
        </header>

        <main className="px-[6.5rem] pb-[6.5rem] pt-[25px]">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
